import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, multasRenainfOrgao } from './types';

export const INITIAL_STATE: multasRenainfOrgao = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): multasRenainfOrgao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.MULTAS_RENAINF_ORGAO_REQUEST: {
				break;
			}

			case Types.MULTAS_RENAINF_ORGAO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.MULTAS_RENAINF_ORGAO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.MULTAS_RENAINF_ORGAO_CLEAR: {
				draft.status = 0;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
